import React, {Component} from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import Colors from "../../Colors";
import PropTypes from "prop-types";

export default class Libetal extends Component {


    static propTypes = {
        height: PropTypes.number,
        width: PropTypes.number,
        color: PropTypes.string,
        backgroundColor: PropTypes.string,
        lColor: PropTypes.string,
        iColor: PropTypes.string,
        bColor: PropTypes.string,
        BColor: PropTypes.string,
        onClick: PropTypes.func
    };

    render() {
        let {
            props: {
                style: {
                    width: sWidth,
                    height: sHeight
                } = {},
                height = sWidth || 80,
                width = sHeight || 80,
                color = Colors.orange,
                backgroundColor = Colors.purple,
                lColor = color,
                iColor = color,
                bColor = color,
                BColor = color,
                onClick,
                ...props
            }

        } = this;

        return (
            <SvgIcon style={{height, width}} onClick={onClick}>
                <path
                    id="rect344"
                    d="M 1.0985148e-5,4.9e-4 C 7.0555594,5e-4 14.111139,4.6e-4 21.166668,5.1e-4 c -7e-6,7.9375 1.5e-5,15.87501 -1.1e-5,23.8125 C 14.111106,23.813 7.0555446,23.81302 0,23.813 7.323528e-6,15.8755 -1.4646992e-5,7.93799 1.0985148e-5,4.9e-4 Z"
                    fill={backgroundColor}/>
                <path

                    id="text68"
                    d="M 7.6868691,5.966 C 6.0271944,9.29551 4.3675197,12.62501 2.707845,15.95452 4.8270955,16.95274 6.9463459,17.95096 9.0655964,18.94918 9.2547321,18.57005 9.4438679,18.19092 9.6330036,17.81179 7.9743624,17.03061 6.3157211,16.24942 4.6570799,15.46824 6.1277912,12.51786 7.5985025,9.56749 9.0692138,6.61711 8.6084322,6.40007 8.1476507,6.18304 7.6868691,5.966 Z"
                    fill={lColor}/>
                <path

                    id="text76"
                    d="m 11.812715,10.2014 c -0.0048,0.004 0.004,0.004 0,0 z m -5.29e-4,0.003 c -0.54186,-0.15583 -0.588177,0.18389 -0.520898,0.6372 0,2.95778 0,5.91555 0,8.87333 1.598492,-0.0347 3.206653,0.0857 4.796431,-0.0977 1.276496,-0.14547 2.473202,-1.20953 2.376774,-2.5652 0.12312,-1.33542 -1.039087,-2.15214 -2.175036,-2.47543 -0.522782,-0.71576 -1.327914,-0.42848 -2.114467,-0.45607 -0.505146,0 -1.010292,0 -1.515438,0 -0.0035,-0.70087 0.007,-1.41568 -0.0052,-2.10788 -0.705026,-0.30671 -0.849615,-1.12656 -0.842166,-1.80825 z m 0.847494,4.96972 c 1.176136,0.0573 2.398643,-0.16365 3.526997,0.2401 1.282301,0.58692 1.075673,2.9013 -0.372127,3.13771 -1.038879,0.19046 -2.103345,0.075 -3.15487,0.10673 0,-1.16151 0,-2.32303 0,-3.48454 z"
                    fill={BColor}/>
                <path

                    id="path78"
                    d="m 12.572456,5.4273 c 0.04878,0.84018 -1.230475,1.14768 -1.568185,0.37611 -0.417428,-0.71494 0.55138,-1.56732 1.207187,-1.06048 0.223484,0.15065 0.362837,0.41488 0.360998,0.68437 z"
                    fill={iColor}/>
                <path

                    id="text72"
                    d="m 16.999855,3.80084 c 0,1.41732 0,2.83464 0,4.25196 C 16.045668,6.22034 13.1133,6.22703 12.050913,7.95218 c -1.02237,1.56881 -1.037455,3.73183 -0.194899,5.38116 0.816531,1.70416 3.347703,2.14744 4.682483,0.81783 0.371022,-0.49677 0.531658,-0.76397 0.461358,-0.0384 -0.103827,0.49657 0.05538,0.73011 0.573481,0.60474 0.391897,0.004 0.902278,0.12665 0.717396,-0.44604 0,-3.49021 0,-6.98041 0,-10.47062 -0.430292,0 -0.860585,0 -1.290877,0 z m -2.202966,3.95015 c 1.427173,-0.0625 2.198483,1.4512 2.193767,2.69838 0.09638,1.28251 -0.25741,2.9933 -1.708766,3.34078 -1.305812,0.36906 -2.471893,-0.76667 -2.598983,-2.01204 -0.201566,-1.33534 -0.11593,-3.07119 1.198309,-3.82362 0.282183,-0.14328 0.600761,-0.20428 0.915673,-0.2035 z"
                    fill={bColor}
                />

            </SvgIcon>
        );
    }
}